module.exports = __webpack_public_path__ + "img/tangle-angel-logo.9814cdf7.png";